import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import DropDown from '../dropdown';
import { Customers } from '../../../api/services/next';
import { useTextResources } from '../../../language';
import { CustomerTypes } from '../constants';

const CustomerDropDown = (props) => {
	const defaultSpec = useMemo(() => ({
		IsActive: true,
	}), [] )
	const text = useTextResources()
	
	return (
		<DropDown
			api={Customers.GetCustomers}
			search
			spec={props?.spec || defaultSpec}
			textField='Name'
			valueField='Id'
			descriptionField={value=>text(CustomerTypes[value.CustomerTypeId])}
			{...props}
		/>
	);
};

CustomerDropDown.propTypes = {
	spec: PropTypes.object,
};

export default CustomerDropDown;
